import { render, staticRenderFns } from "./TimePunchReceipt.vue?vue&type=template&id=41706193&scoped=true"
import script from "./TimePunchReceipt.vue?vue&type=script&lang=js"
export * from "./TimePunchReceipt.vue?vue&type=script&lang=js"
import style0 from "./TimePunchReceipt.vue?vue&type=style&index=0&id=41706193&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41706193",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41706193')) {
      api.createRecord('41706193', component.options)
    } else {
      api.reload('41706193', component.options)
    }
    module.hot.accept("./TimePunchReceipt.vue?vue&type=template&id=41706193&scoped=true", function () {
      api.rerender('41706193', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/TimePunchReceipt.vue"
export default component.exports